"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function decorate(target, decorators) {
    return lodash_1.reduce([].concat(decorators), function (acc, decorator) { return decorator(acc); }, target);
}
exports.decorate = decorate;
//# sourceMappingURL=decorator.js.map